import {
  FETCH_WORKFLOW_CONFIGS,
  FETCH_WORKFLOW_CONFIGS_SUCCESS,
  FETCH_WORKFLOW_CONFIGS_FAILED,
  EDIT_WORKFLOW_CONFIG
} from "../store/types";

const INITIAL_STATE = {
  configs: [],
  loading: false,
  error: {
    flag: false,
    msg: null
  }
};

export const workflowconfigreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_WORKFLOW_CONFIGS:
      return {
        ...state,
        loading: true
      };
    case FETCH_WORKFLOW_CONFIGS_SUCCESS:
      return {
        ...state,
        configs: action.payload || [],
        loading: false,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_WORKFLOW_CONFIGS_FAILED:
      return {
        ...state,
        configs: [],
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_WORKFLOW_CONFIG:
      return state;
    default:
      return state;
  }
};
